import {Types} from 'mongoose';
import store from '@/store';
import CrudAccessManager from '@/classes/clientOnly/permissionTreeResources/classes/CrudAccessManager';
import {CrudEntityTypes} from '@/classes/clientOnly/permissionTreeResources/enums/CrudEntityTypes';
import {CrudActionTypes} from '@/classes/clientOnly/permissionTreeResources/enums/CrudActionTypes';
import {LoginTypes} from '@/enums/LoginTypes.enum';

function cam(): CrudAccessManager {
    return store.state.crudAccessManager as CrudAccessManager;
}

/** May the user read these fields of all accessible entities of the type (used for filters on other services) */
export function canReadType(type: CrudEntityTypes, ...fields: string[]): boolean {
    const manager = cam();
    return !!manager && manager.canAccessType(type, CrudActionTypes.READ) && manager.canReadAllProvided(type, ...fields);
}

/** May the user read these fields of this specific entity */
export function canReadEntity(type: CrudEntityTypes.STUDENT | CrudEntityTypes.EMPLOYEE | CrudEntityTypes.COURSE | CrudEntityTypes.PRODUCT
                                  | CrudEntityTypes.EVENT_INFO,
                              id: Types.ObjectId, ...fields: string[]): boolean {
    const manager = cam();
    return !!manager && manager.entity(type, id).canReadAll(...fields);
}

/** Entity types behind the areas of the palette (recent visits additionally know schools of acquisition lists) */
const AREA_TYPES: Record<string, CrudEntityTypes[]> = {
    students: [CrudEntityTypes.STUDENT],
    parents: [CrudEntityTypes.PARENT],
    employees: [CrudEntityTypes.EMPLOYEE],
    teachers: [CrudEntityTypes.EMPLOYEE],
    applicants: [CrudEntityTypes.EMPLOYEE],
    institutions: [CrudEntityTypes.INSTITUTION],
    courses: [CrudEntityTypes.COURSE],
    products: [CrudEntityTypes.PRODUCT],
    trainings: [CrudEntityTypes.EVENT_INFO],
    acquisitionListItems: [CrudEntityTypes.ACQUISITION_LIST, CrudEntityTypes.INSTITUTION],
};

/** May the user read the area (filter pills, recent visits, pins)? Partner logins never use the palette */
export function canReadArea(area: string): boolean {
    const manager = cam();
    if (!manager || store.state.userType === LoginTypes.PARTNER) {
        return false;
    }
    const types = AREA_TYPES[area];
    return !!types && types.every((type) => manager.canAccessType(type, CrudActionTypes.READ));
}
